const _ = require('./enum');

module.exports = {
  [_.BALANCE]: { id: _.BALANCE, label: 'Balance' },
  [_.FEE]: { id: _.FEE, label: 'Fee' },
  [_.MISCELLANEOUS]: { id: _.MISCELLANEOUS, label: 'Miscellaneous' },
};
